const normalizeBaseUrl = (url: string): string => url.replace(/\/+$/, "");
const joinUrl = (baseUrl: string, path: string): string =>
  `${normalizeBaseUrl(baseUrl)}/${path.replace(/^\/+/, "")}`;

const getEnv = (key: string, fallback: string): string =>
  (import.meta.env as Record<string, string | undefined>)[key]?.trim() || fallback;

const DEFAULTS = {
  audioServerUrl:
    "https://australia-southeast2-helixa-ai.cloudfunctions.net/audioProcessing",
  deepgramWsUrl: "wss://api.deepgram.com/v1/listen",
  wordServerUrl: "https://generatedocx-iuqhn5zc6a-km.a.run.app",
  cloudFunctionsBaseUrl: "https://australia-southeast2-helixa-ai.cloudfunctions.net",
  privacyPolicyUrl: "https://helixa.com.au/privacy-policy?embed=true",
  termsOfServiceUrl: "https://helixa.com.au/terms-of-service?embed=true",
  usagePolicyUrl: "https://helixa.com.au/usage-policy?embed=true",
  doNotSellUrl: "https://helixa.com.au/do-not-sell?embed=true",
  faviconServiceUrl: "https://www.google.com/s2/favicons",
  quillCssUrl: "https://cdn.quilljs.com/1.3.6/quill.snow.css",
  quillJsUrl: "https://cdn.quilljs.com/1.3.6/quill.min.js",
  interFontCssUrl:
    "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap",
} as const;

export const AUDIO_SERVER_URL = normalizeBaseUrl(
  getEnv("VITE_AUDIO_SERVER_URL", DEFAULTS.audioServerUrl),
);
export const DEEPGRAM_WS_URL = getEnv("VITE_DEEPGRAM_WS_URL", DEFAULTS.deepgramWsUrl);
export const WORD_SERVER_URL = normalizeBaseUrl(
  getEnv("VITE_WORD_SERVER_URL", DEFAULTS.wordServerUrl),
);
export const CLOUD_FUNCTIONS_BASE_URL = normalizeBaseUrl(
  getEnv("VITE_CLOUD_FUNCTIONS_BASE_URL", DEFAULTS.cloudFunctionsBaseUrl),
);

export const PRIVACY_POLICY_URL = getEnv(
  "VITE_PRIVACY_POLICY_URL",
  DEFAULTS.privacyPolicyUrl,
);
export const TERMS_OF_SERVICE_URL = getEnv(
  "VITE_TERMS_OF_SERVICE_URL",
  DEFAULTS.termsOfServiceUrl,
);
export const USAGE_POLICY_URL = getEnv(
  "VITE_USAGE_POLICY_URL",
  DEFAULTS.usagePolicyUrl,
);
export const DO_NOT_SELL_URL = getEnv(
  "VITE_DO_NOT_SELL_URL",
  DEFAULTS.doNotSellUrl,
);
export const FAVICON_SERVICE_URL = getEnv(
  "VITE_FAVICON_SERVICE_URL",
  DEFAULTS.faviconServiceUrl,
);
export const QUILL_CSS_URL = getEnv("VITE_QUILL_CSS_URL", DEFAULTS.quillCssUrl);
export const QUILL_JS_URL = getEnv("VITE_QUILL_JS_URL", DEFAULTS.quillJsUrl);
export const INTER_FONT_CSS_URL = getEnv(
  "VITE_INTER_FONT_CSS_URL",
  DEFAULTS.interFontCssUrl,
);

// Centralized API endpoints built from environment-driven base URLs.
export const DEEPGRAM_TOKEN_URL = joinUrl(AUDIO_SERVER_URL, "/deepgram-token");
export const CHAT_WITH_HELIXA_URL = joinUrl(AUDIO_SERVER_URL, "/chat-with-helixa");
export const EXTRACT_MEDICAL_HISTORY_URL = joinUrl(
  AUDIO_SERVER_URL,
  "/extract-medical-history",
);
export const GENERATE_REFERRAL_LETTER_URL = joinUrl(
  AUDIO_SERVER_URL,
  "/generate-referral-letter",
);
export const EXTRACT_TASKS_URL = joinUrl(AUDIO_SERVER_URL, "/extract-tasks");
export const PROCESS_TRANSCRIPT_URL = joinUrl(AUDIO_SERVER_URL, "/process-transcript");
export const UPLOAD_JSON_STREAM_URL = joinUrl(AUDIO_SERVER_URL, "/upload-json-stream");
export const TRANSCRIBE_AUDIO_URL = joinUrl(AUDIO_SERVER_URL, "/transcribe-audio");
export const GENERATE_DOCX_URL = joinUrl(WORD_SERVER_URL, "/generate-docx");
export const GENERATE_PDF_URL = joinUrl(CLOUD_FUNCTIONS_BASE_URL, "/generatePdf/generate-pdf");
// keepalive fetch endpoint for beforeunload saves (httpsCallable cannot survive page unload)
export const UPDATE_NOTE_KEEPALIVE_URL = joinUrl(CLOUD_FUNCTIONS_BASE_URL, "/updateNote");
